import { userApis } from 'services/UserService/apis';

export const getUserSettingsRequest = async () => {
  return userApis.user.adminApi.getUserSettings();
};
